module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Like-aee690f1f8ca6a06fd795e51be80b887.svg";